import { data } from "jquery";

(function($){

	window.windowOnLoad(function(e) {
		if ( $('#ts').length > 0 ) {

		let inst_name = $('#sentimentstable').data('inst-name');
		let inst_id = $('#sentimentstable').data('inst-id');

		  $.ajax({
			url:'//content.webapi-services.net/api/tradingSentiments?b='+languageAttributes.broker+'&instruments=['+inst_id+']',
			method: 'GET',
			dataType:'json',
			success: function(data){
				initSentiments(inst_name, data[0][inst_id]);
			}
		})
    }
    
});

let text = '% of traders think the ';
let text1 = ' will ';


switch (languageAttributes.languageCode) {
	case 'es':
		text = '% de comerciantes piensa que ';
		text1 = ' ';
	  break;
	case 'ar':
		text = '٪ من المتداولون يظنون أن ال ';
		text1 = ' سوف ';
		break;
  }



function initSentiments(name, data) {
	let sentimentstable = $(document.getElementById('sentimentstable'));
	
	
	let status = 'Rise'; // currency is up	
	let first = data*1, second = 100 - first;
	
		
	if (parseInt(first, 10) < parseInt(second)) status = 'Fall'; //currency is down
		
	$('#sent_first').css('height',(parseInt(first) - 1) + '%');
	$('#sent_second').css('height',second+'%');
	$('#sent_first_text').text(first+'%');
	$('#sent_second_text').text(second+'%');

	let status_trnasltion = status;

	switch (languageAttributes.languageCode) {
		case 'es':
			status_trnasltion = status_trnasltion == 'Rise' ? 'Sube' : 'Baja' ;
		  break;
		case 'ar':
			status_trnasltion = status_trnasltion == 'Rise' ? 'يرتفع' : 'ينخفض' ;
		break;
		
	  }
	


	if (first >= second) {
		$('#sentimentstable').find('.text').html(first + text + name + text1 + status_trnasltion);
	}
	else {
		$('#sentimentstable').find('.text').html(second + text + name + text1 + status_trnasltion);
	}

	sentimentstable.show();
	
	
}


})(window.jQuery);